import { Inject, Injectable } from '@angular/core';
import { fuzzyKeyLookup } from '@shared/utilities/fuzzyKeyLookup';
import { ModelNameService } from '@shared/naming/model-name.service';
import { FieldNameService } from '@shared/naming/field-name.service';
import { ApiMessages, ApiMessageTemplate, MessageDetails } from '../../tokens/api-messages';

type FindOptions = {
  scope?: string;
  default?: string;
};

@Injectable({
  providedIn: null,
  deps: [ModelNameService, FieldNameService, ApiMessages],
})
export class ApiMessagingService {
  constructor(
    public modelName: ModelNameService,
    public fieldNames: FieldNameService,
    @Inject(ApiMessages) public apiMessages: ApiMessages
  ) {}

  message(key: string, details?: MessageDetails, options?: FindOptions): string {
    const template = this.findTemplate(key, options);
    return (
      (template && template(this.modelName, this.fieldNames, details)) ||
      $localize`Message not found.`
    );
  }

  findTemplate(key: string, options?: FindOptions): ApiMessageTemplate | undefined {
    return (
      (options?.scope && this.templateSearch([options.scope, key].join('.'))) ||
      this.templateSearch(key) ||
      (options?.default && this.templateSearch(options.default)) ||
      undefined
    );
  }

  templateSearch(key: string): ApiMessageTemplate | undefined {
    return fuzzyKeyLookup(this.apiMessages, key);
  }
}
